export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/cf5717c2c697e32971944c688809eb3b/a774a8c5137c798919d35a39b8673fd2.png" 
                alt="MECA SERVICES Logo" 
                className="h-10 w-auto"
              />
              <span className="text-xl font-bold">MECA SERVICES</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Votre partenaire de confiance pour des solutions de chauffage écologiques et performantes depuis 2020.
            </p>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Services</h4>
            <ul className="space-y-2">
              <li>
                <a href="#services" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Pompes à chaleur
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Ballons thermodynamiques
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Isolation
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Plomberie
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Navigation</h4>
            <ul className="space-y-2">
              <li>
                <a href="#about" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  À propos
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Nos services
                </a>
              </li>
              <li>
                <a href="#products" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Nos produits
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-teal-400 mt-1"></i>
                <a href="mailto:mecaservices@yahoo.com" className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  mecaservices@yahoo.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-user-line text-teal-400 mt-1"></i>
                <span className="text-gray-400 text-sm">Particuliers</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} MECA SERVICES. Tous droits réservés.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
